module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-right-top-ties-remnants.07a97862.png";